export default class PollOptionModel {
    public Text: string = "";
    public Color: string = "";
}